function load_cart() {
  fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
    .then((response) => response.text())
    .then((responseText) => {
      const cartid = 'cart-drawer';
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const destination = document.querySelector('.cart-sidebar');
      const source = html.getElementById(cartid);
      if (source && destination) destination.innerHTML = source.innerHTML;
      document.querySelectorAll('.item-remove').forEach(function (cartRemove) {
        var data_line = cartRemove.dataset.line;
        cartRemove.addEventListener('click', (evt) => removeItem(data_line));
      });
      document.querySelectorAll('.quantity-minus').forEach(function (minus) {
        var data_line = minus.dataset.line;
        minus.addEventListener('click', function () {
          var currentQuantity = parseInt(document.getElementById(`Quantity-${data_line}`).value) - 1;
          document.getElementById(`Quantity-${data_line}`).value = currentQuantity;
          updateItem(data_line, currentQuantity);
        });
      });
      document.querySelectorAll('.quantity-plus').forEach(function (plus) {
        var data_line = plus.dataset.line;
        plus.addEventListener('click', function () {
          var currentQuantity = parseInt(document.getElementById(`Quantity-${data_line}`).value) + 1;
          document.getElementById(`Quantity-${data_line}`).value = currentQuantity;
          updateItem(data_line, currentQuantity);
        });
      });


      document.querySelectorAll('.promo-btm .grid-color a:not(.quick_view_button)').forEach(function (colors) {

        colors.addEventListener('click', function (e) {

          e.preventDefault();
          e.stopImmediatePropagation();

          let parentPromo = colors.closest('.cp-promo-inr');

          // Image change
          parentPromo.querySelector('.promo-media img')
            .setAttribute('srcset', colors.getAttribute('data-img'));

          let active_id = colors.getAttribute('data-id');

          // Remove active color only inside current promo
          parentPromo.querySelectorAll('.grid-color a:not(.quick_view_button)')
            .forEach(el => el.classList.remove('active-color'));

          colors.classList.add('active-color');

          // Remove active variant only inside current promo
          parentPromo.querySelectorAll('.grid-variant-outer ul')
            .forEach(el => el.classList.remove('active-variant-wrap'));

          // Loop with break support
          let variants = parentPromo.querySelectorAll('.grid-variant-outer ul');

          for (let variant of variants) {
            let ids = variant.getAttribute('data-id');

            if (active_id == ids) {
              variant.classList.add('active-variant-wrap');
              break; // loop stop thai jase ✅
            }
          }

        });

      });
      // document.querySelectorAll('.promo-btm .grid-color a').forEach(function (colors) {
      //   colors.addEventListener('click', function (e) {
      //     e.preventDefault();
      //     e.stopImmediatePropagation();
      //     colors.closest('.cp-promo-inr').querySelector('.promo-media img').setAttribute('srcset',colors.getAttribute('data-img'));
      //     let id = colors.getAttribute('data-id');
      //     document.querySelectorAll('.promo-btm .grid-color a').forEach(function (rm_colors) {
      //       rm_colors.classList.remove('active-color');
      //     });
      //     colors.classList.add('active-color');
      //     document.querySelectorAll('.promo-variant .grid-variant-outer').forEach(function (variant) {
      //       let ids = variant.getAttribute('data-id');
      //       let active_id = document.querySelector('.promo-btm .grid-color a.active-color').getAttribute('data-id');
      //       console.log(active_id,'active_id',ids);
      //       if(active_id == ids){
      //         console.log('match');
      //         document.querySelectorAll('.promo-variant .grid-variant-outer').forEach(function (rm_variant){
      //           rm_variant.classList.remove('active-variant-wrap');
      //         });
      //         variant.classList.add('active-variant-wrap');
      //         return false;
      //       }
      //     });
      //   });
      // });
      document.querySelectorAll('.header-cart').forEach(function (cartButton) {
        cartButton.addEventListener('click', function (e) {
          document.querySelector('body').classList.add('open-drawer');
          document.querySelector('body').classList.remove('open-menu', 'open-search', 'open-sort', 'open-filter');
        });
      });
      document.querySelectorAll('.overlay-box, .cart-drawer-close').forEach(function (cartButton) {
        cartButton.addEventListener('click', function (e) {
          document.querySelector('body').classList.remove('open-drawer','open-quick-buy', 'open-menu', 'open-search', 'open-sort', 'open-filter', 'open-account-popup');
        });
      });

      let items = document.querySelectorAll('.item-row');
      let promos = document.querySelectorAll('.cp-promo-inr');

      let cartProductIds = [];
      items.forEach(item => {
        cartProductIds.push(item.getAttribute('data-product-id'));
      });

      let promoActivated = false;
      for (let j = 0; j < promos.length; j++) {

        let mainId = promos[j].getAttribute('main-id');
        let promoId = promos[j].getAttribute('promo-id');

        if (
          cartProductIds.includes(mainId) &&
          !cartProductIds.includes(promoId)
        ) {
          promos[j].classList.add('active');
          promoActivated = true;
          break;
        }
      }

      let allMainIds = [];
      let allPromoIds = [];
      
      document.querySelectorAll('.cp-promo-inr').forEach(function (cp_promo) {
        let mainId = cp_promo.getAttribute('main-id');
        let promoId = cp_promo.getAttribute('promo-id');
        if (!allMainIds.includes(mainId)) allMainIds.push(mainId);
        if (!allPromoIds.includes(promoId)) allPromoIds.push(promoId);
      });
      
      let mainProductCount = 0;
      cartProductIds.forEach(id => {
        if (allMainIds.includes(id)) {
          let productRow = document.querySelector(`.item-row[data-product-id="${id}"]`);
          if (productRow) {
            let qtyInput = productRow.querySelector('input[type="number"]');
            mainProductCount += qtyInput ? parseInt(qtyInput.value) : 1;
          }
        }
      });
      
      let promoProductCount = 0;
      cartProductIds.forEach(id => {
        if (allPromoIds.includes(id)) {
          let productRow = document.querySelector(`.item-row[data-product-id="${id}"]`);
          if (productRow) {
            let qtyInput = productRow.querySelector('input[type="number"]');
            promoProductCount += qtyInput ? parseInt(qtyInput.value) : 1;
          }
        }
      });
      
      let promoSuccessEl = document.querySelector('.promo-success');
      if (promoSuccessEl) {
        if (mainProductCount > 0 && promoProductCount >= mainProductCount) {
          promoSuccessEl.classList.add('active-success');
          localStorage.removeItem('Promotion');
          document.querySelectorAll('.cp-promo-inr').forEach(function (promo) {
            promo.classList.remove('active');
          });
        } else {
          promoSuccessEl.classList.remove('active-success');
        }
      }
      empty_cart();
      productRecommended();
      accordian();
      if (typeof window.$th_refreshWishlistItems === 'function') 
          window.$th_refreshWishlistItems();

      updateExpectedDate();
      
      if (typeof bindQuickViewButtons === 'function') {
        bindQuickViewButtons();
      }
      if (typeof quickAddButton === 'function') {
        quickAddButton();
      }
      if (typeof quickproductrow === 'function') {
        quickproductrow();
      }

    });

}
load_cart();
function removeItem(data_line) {
  const data = { line: data_line, quantity: 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      if (document.location.href.indexOf('/cart') > -1) {
        window.location.href = '/cart';
      } else {
        load_cart();
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function updateItem(data_line, quantity) {
  const data = { line: data_line, quantity: quantity };
  let error_grid = document.querySelector(`#Quantity-${data_line}`).closest('.item-row').querySelector('.grid-error');
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      if (document.location.href.indexOf('/cart') > -1) {
        window.location.href = '/cart';
      } else {
        if(data.status == 422)
          {
              error_grid.innerHTML = data.description;
              setTimeout(function(e){
                    error_grid.innerHTML = '';
                    load_cart();

              },2000);
        }else{
          load_cart();
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}



async function productRecommended() {
  const firstItem = document.querySelector('.item-row');
  if (!firstItem) return;

  const productId = firstItem.getAttribute('data-product-id');
  const container = document.getElementById('complementary-products-container');
  if (!container) return;

  const wrapper = container.querySelector('.swiper-wrapper');
  if (!wrapper) return;

  // wrapper.innerHTML = '<li class="swiper-slide loading">Loading Recommendations...</li>';
  const SECTION_ID = 'product-recommended-grid';

  try {
    const response = await fetch(`/recommendations/products.json?product_id=${productId}&recommendation_method=complementary&limit=4`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const data = await response.json();
    const handles = (data.products || []).map(p => p.handle).filter(Boolean);

    if (handles.length === 0) {
      wrapper.innerHTML = '<li class="swiper-slide">No recommendations found.</li>';
      return;
    }

    const sections = await Promise.all(
      handles.map(async handle => {
        try {
          const r = await fetch(`/products/${handle}?sections=${SECTION_ID}`);
          const json = await r.json();
          return json[SECTION_ID];
        } catch (err) {
          console.error(`Failed to load ${handle}:`, err);
          return `<div class="error">Failed to load ${handle}</div>`;
        }
      })
    );

    wrapper.innerHTML = sections
      .map(sectionHTML => `<li class="swiper-slide">${sectionHTML}</li>`)
      .join('');

    // productrow();
    quickproductrow();
    quickAddButton();
    bindQuickViewButtons();
    // $th_refreshWishlistItems();
    // updateFLCprice();
    

    if (window.cartRecommendedSwiper) {
      window.cartRecommendedSwiper.destroy(true, true);
      window.cartRecommendedSwiper = null;
    }

    if (window.Swiper) {
      window.cartRecommendedSwiper = new Swiper('.cart-recommended-slider', {
        slidesPerView: 'auto',
        spaceBetween: 1,
        slidesOffsetAfter: 12,
        // pagination: {
        //   el: '.swiper-pagination',
        //   type: 'progressbar',
        // },
        scrollbar: {
          el: ".cart-recommended-slider .swiper-scrollbar",
          draggable: true,
        },
        grabCursor: true,
        on: {
          scrollbarDragStart() {
            document.body.classList.add('dragging');
          },
          scrollbarDragEnd() {
            document.body.classList.remove('dragging');
          }
        },
        breakpoints: {
          991:{ slidesOffsetAfter: 24 },
        },
      });

    }

  } catch (error) {
    console.error('Error fetching recommendations:', error);
    wrapper.innerHTML = '<li class="swiper-slide error">Error loading recommended products.</li>';
  }
}

function empty_cart(){
  window.cartRecommendedSwiper = new Swiper('.empty_cart-recommended-slider', {
    slidesPerView: 'auto',
    spaceBetween: 1,

    scrollbar: {
          el: ".empty_cart-recommended-slider .swiper-scrollbar",
          draggable: true,
        },
    grabCursor: true,
    on: {
      scrollbarDragStart() {
        document.body.classList.add('dragging');
      },
      scrollbarDragEnd() {
        document.body.classList.remove('dragging');
      }
    },
    slidesOffsetAfter: 12,
    breakpoints: {
      992: {
        slidesOffsetAfter: 24,
      },
    },
  });
  quickAddButton();
  quickproductrow();
  bindQuickViewButtons();
  // productrow();
  // updateFLCprice();
}



function updateExpectedDate() {
  const items = document.querySelectorAll('.drawer-middle .item-row');
  const firstWithEdDiv = Array.from(items).find(item => item.querySelector('.ed-div'));
  if (firstWithEdDiv) {
    const edDiv = firstWithEdDiv.querySelector('.ed-div');
    const text = edDiv.textContent.trim();
    const parts = text.split(':');
    const lastPart = parts[parts.length - 1].trim();
    const target = document.querySelector('.drawer-footer .expected-date.normal');
    if (target) {
      target.textContent = lastPart;
      target.style.filter = 'blur(0)';
      target.classList.add('remove-blur');
    }
  }
}
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(updateExpectedDate, 1000);
});

document.addEventListener("DOMContentLoaded", function() {
  function initApplePayButtonCheck() {
    const applePayButton = document.querySelector(".cart-apple-pay-btn");
    if (!applePayButton) {
      setTimeout(initApplePayButtonCheck, 500);
      return;
    }
    const ua = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/.test(ua);
    const isSafari = /Safari/.test(ua) && !/Chrome|CriOS|FxiOS|EdgiOS/.test(ua);
    if (!(isIOS && isSafari)) {
      applePayButton.style.display = "none";
    }
  }
  initApplePayButtonCheck();
});







    